module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp123_8011.959a0839.png";